import ContactPagePc from './components/ContactPagePc/ContactPagePc'
import ContactPageMobile from './components/ContactPageMobile/ContactPageMobile'
import useIsMobile from '@/helpers/commonHooks/useIsMobile'

function ContactPage() {
  const isMobile = useIsMobile()
  return isMobile ? <ContactPageMobile /> : <ContactPagePc />
}

export default ContactPage
